import { useState } from "react";
import AddNewSong from "./AddNewSong";
import BrowseSongs from "./BrowseSongs";
import PlaylistInput from "./PlaylistInput";
import { FaPlus, FaTrash } from "react-icons/fa";
import { uuidv4 } from "@firebase/util";

function CreateNewPlaylist({
    allSongs,
    newSongs,
    setNewSongs,
    newPlaylistName,
    setNewPlaylistName,
    newQuestions,
    setNewQuestions,
    enableQuestions,
    setEnableQuestions,
}) {
    const [isAddSongModalOpen, setIsAddSongModalOpen] = useState(false);
    const [newQuestionText, setNewQuestionText] = useState("");
    return (
        <div
            className="create-new-playlist-container"
            style={{
                width: "100%",
                height: "100%",
                backgroundColor: "#161f33",
                display: "flex",
                flexDirection: "column",
                overflow: "hidden",
                padding: "0 0.5vh",
                boxSizing: "border-box",
            }}
        >
            <div
                style={{
                    width: "100%",
                    boxSizing: "border-box",
                    flexShrink: 0,
                    padding: "1vh",
                    paddingTop: 0,
                }}
            >
                <label
                    style={{
                        color: "white",
                        fontSize: 13,
                        marginBottom: "0.5vh",
                        display: "block",
                        textAlign: "left",
                        width: "100%",
                    }}
                >
                    Navn på spilleliste
                </label>
                <PlaylistInput
                    placeholder="f.eks. Min favorittliste"
                    value={newPlaylistName}
                    onChange={(e) => setNewPlaylistName(e.target.value)}
                    extraStyle={{
                        width: "100%",
                        margin: 0,
                        marginBottom: 0,
                        boxSizing: "border-box",
                    }}
                />
            </div>
            {/* Bonus Questions Section */}
            <div
                style={{
                    width: "100%",
                    boxSizing: "border-box",
                    flexShrink: 0,
                    padding: "1vh",
                    borderTop: "1px solid #2a3854",
                    backgroundColor: "#161f33",
                }}
            >
                <div
                    style={{
                        display: "flex",
                        alignItems: "center",
                        marginBottom: "1vh",
                    }}
                >
                    <input
                        type="checkbox"
                        checked={enableQuestions}
                        onChange={(e) => setEnableQuestions(e.target.checked)}
                        style={{
                            marginRight: "1vh",
                            cursor: "pointer",
                        }}
                    />
                    <label
                        style={{
                            color: "white",
                            fontSize: 13,
                            cursor: "pointer",
                        }}
                    >
                        Inkluder bonusspørsmål
                    </label>
                </div>
                {enableQuestions && (
                    <div
                        style={{
                            display: "flex",
                            flexDirection: "column",
                            gap: "1vh",
                        }}
                    >
                        <div
                            style={{
                                display: "flex",
                                gap: "0.5vh",
                            }}
                        >
                            <PlaylistInput
                                placeholder="f.eks. Hvilken norsk gruppe ga ut hiten Italia i 2022?"
                                value={newQuestionText}
                                onChange={(e) =>
                                    setNewQuestionText(e.target.value)
                                }
                                extraStyle={{
                                    flex: 1,
                                    margin: 0,
                                    boxSizing: "border-box",
                                }}
                                onKeyDown={(e) => {
                                    if (
                                        e.key === "Enter" &&
                                        newQuestionText.trim()
                                    ) {
                                        setNewQuestions([
                                            ...newQuestions,
                                            {
                                                id: uuidv4(),
                                                question:
                                                    newQuestionText.trim(),
                                            },
                                        ]);
                                        setNewQuestionText("");
                                    }
                                }}
                            />
                            <div
                                onClick={() => {
                                    if (newQuestionText.trim()) {
                                        setNewQuestions([
                                            ...newQuestions,
                                            {
                                                id: uuidv4(),
                                                question:
                                                    newQuestionText.trim(),
                                            },
                                        ]);
                                        setNewQuestionText("");
                                    }
                                }}
                                style={{
                                    backgroundColor: "#4db193",
                                    color: "white",
                                    border: "none",
                                    borderRadius: "0.5vh",
                                    padding: "0 1.5vh",
                                    cursor: "pointer",
                                    display: "flex",
                                    alignItems: "center",
                                    justifyContent: "center",
                                    fontSize: 14,
                                    fontWeight: 500,
                                    transition: "background-color 0.2s ease",
                                }}
                                onMouseEnter={(e) => {
                                    e.currentTarget.style.backgroundColor =
                                        "#3d9a7a";
                                }}
                                onMouseLeave={(e) => {
                                    e.currentTarget.style.backgroundColor =
                                        "#4db193";
                                }}
                            >
                                <FaPlus />
                            </div>
                        </div>
                        {newQuestions.length > 0 && false && (
                            <div
                                style={{
                                    maxHeight: "15vh",
                                    overflowY: "auto",
                                    display: "flex",
                                    flexDirection: "column",
                                    gap: "0.5vh",
                                    marginTop: "0.5vh",
                                }}
                            >
                                {newQuestions.map((q, index) => (
                                    <div
                                        key={q.id}
                                        style={{
                                            backgroundColor: "#0f1624",
                                            padding: "0.8vh",
                                            borderRadius: "0.5vh",
                                            display: "flex",
                                            justifyContent: "space-between",
                                            alignItems: "center",
                                            fontSize: 12,
                                            color: "white",
                                        }}
                                    >
                                        <span>{q.question}</span>
                                        <div
                                            onClick={() => {
                                                setNewQuestions(
                                                    newQuestions.filter(
                                                        (item) =>
                                                            item.id !== q.id
                                                    )
                                                );
                                            }}
                                            style={{
                                                color: "#ef4444",
                                                cursor: "pointer",
                                                marginLeft: "1vh",
                                                padding: "0.3vh",
                                            }}
                                        >
                                            <FaTrash size={12} />
                                        </div>
                                    </div>
                                ))}
                            </div>
                        )}
                    </div>
                )}
            </div>
            <div
                className="create-new-playlist-content"
                style={{
                    display: "flex",
                    flexDirection: "column",
                    flex: 1,
                    overflow: "hidden",
                    minHeight: 0,
                }}
            >
                <BrowseSongs
                    allSongs={allSongs}
                    setNewSongs={setNewSongs}
                    newSongs={newSongs}
                />
                <div
                    style={{
                        flexShrink: 0,
                        padding: "3vh 1vh 3vh 1vh",
                        borderTop: "1px solid #2a3854",
                        backgroundColor: "#161f33",
                    }}
                >
                    <div
                        onClick={() => setIsAddSongModalOpen(true)}
                        style={{
                            width: "100%",
                            backgroundColor: "#3a5f8f",
                            display: "flex",
                            justifyContent: "center",
                            alignItems: "center",
                            borderRadius: "0.5vh",
                            cursor: "pointer",
                            padding: "1vh",
                            fontSize: 14,
                            fontWeight: 500,
                            color: "white",
                            transition: "background-color 0.2s ease",
                            boxSizing: "border-box",
                        }}
                        onMouseEnter={(e) => {
                            e.currentTarget.style.backgroundColor = "#2a4d7a";
                        }}
                        onMouseLeave={(e) => {
                            e.currentTarget.style.backgroundColor = "#3a5f8f";
                        }}
                    >
                        <FaPlus style={{ marginRight: "0.5vh" }} />
                        Legg til ny sang
                    </div>
                </div>
                <AddNewSong
                    setNewSongs={setNewSongs}
                    newSongs={newSongs}
                    isOpen={isAddSongModalOpen}
                    onClose={() => setIsAddSongModalOpen(false)}
                />
            </div>
        </div>
    );
}

export default CreateNewPlaylist;
